// export const apiUrl = 'https://developfix.decentrawood.com'
// export const apiUrl = "https://backend.decentrawood.com";
// export const apiUrl = "http://localhost:8080";
export const apiUrl = "https://backend.blockcoaster.com";
